import { createQuery } from 'QueryKit'
import {
  annotationDetails,
  measurementDetails,
  getInspectionImagesFiltered,
} from 'API/definitions/iris/inspection-image'
import { annotationDetailsMessage, measurementDetailsMessage } from 'API/messages/mutations/iris/inspection-image'

type Response = {
  annotation_uuid: string
  annotation_status: 'Confirmed' | 'Rejected'
  annotation_type: string
  defect_action: 'None' | 'Rejected' | 'Unknown'
  defect_bounds: number[][]
  defect_height: string
  defect_type: 'None' | 'Damage' | 'Scratch' | 'Dent'
  defect_width: string
  is_annotation: boolean
  confidence: number
}

type Variables = {
  imageUuid: string
  imageName: string
}

const useAnnotationDetailsQuery = createQuery<Response, Variables, Error>({
  primaryKey: 'inspection-image_annotation-details',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  queryFn: ({ queryKey: [primaryKey, variables] }) => {
    return annotationDetails(variables.imageUuid)
  },
  message: annotationDetailsMessage,
})

const useMeasurementDetailsQuery = createQuery<any, any, Error>({
  primaryKey: 'inspection-image_measurement-details',
  queryFn: async ({ queryKey: [primaryKey, variables] }) => {
    return measurementDetails(variables.imageUuid)
  },
  message: measurementDetailsMessage,
})

//TODO add types to createQuery - dependent on implementing OpenAPI to type implementation
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useGetInspectionImagesFiltered = createQuery<any, any, Error>({
  primaryKey: 'inspection-images-filtered',
  queryFn: ({ queryKey: [primaryKey, variables] }) => {
    return getInspectionImagesFiltered(variables?.filterQueryParams)
  },
  message: 'Failed to get images',
})

export { useAnnotationDetailsQuery, useMeasurementDetailsQuery, useGetInspectionImagesFiltered }
